/** Parse auth tokens from query string or Supabase implicit-flow hash. */
export function getRecoveryParamsFromUrl(): {
  access_token: string | null;
  refresh_token: string | null;
  type: string | null;
} {
  const search = window.location.search;
  const hash = window.location.hash.substring(1);

  const searchStr =
    search && search !== ""
      ? search
      : hash.includes("?")
        ? hash.split("?")[1]
        : hash;

  if (!searchStr) {
    return { access_token: null, refresh_token: null, type: null };
  }

  const params = new URLSearchParams(searchStr);
  return {
    access_token: params.get("access_token"),
    refresh_token: params.get("refresh_token"),
    type: params.get("type"),
  };
}

export function isRecoveryOrInvite(
  type: string | null,
): type is "recovery" | "invite" {
  return type === "recovery" || type === "invite";
}

export function buildSetPasswordPath(
  access_token: string,
  refresh_token: string,
  type: string,
): string {
  const search = new URLSearchParams({
    access_token,
    refresh_token,
    type,
  });
  return `/set-password?${search.toString()}`;
}

export function redirectToSetPasswordPage(
  access_token: string,
  refresh_token: string,
  type: string,
): void {
  const path = buildSetPasswordPath(access_token, refresh_token, type);
  window.location.replace(
    `${window.location.pathname}${window.location.search}#${path}`,
  );
}

/**
 * Supabase verify links land on `/#access_token=...` which conflicts with
 * HashRouter (`/#/route`). Rewrite to `/#/set-password?access_token=...`.
 * @returns true when a redirect was started (caller must not mount React).
 */
export function normalizeRecoveryHash(): boolean {
  if (typeof window === "undefined") return false;

  const hash = window.location.hash.substring(1);
  if (!hash || hash.startsWith("/")) return false;

  const { access_token, refresh_token, type } = getRecoveryParamsFromUrl();
  if (!isRecoveryOrInvite(type) || !access_token || !refresh_token) {
    return false;
  }

  redirectToSetPasswordPage(access_token, refresh_token, type);
  return true;
}
